import { create } from 'zustand';

const useSearchNewStore = create((set) => ({
    specialValue: '', // Arama değeri için kullanılacak özel değer

    setSearchValue: (value) => set({ specialValue: value }), // Arama değerini güncelleyen fonksiyon
}));

export default useSearchNewStore;
